import LoadingBlock from './loadingBlock';

export default function LoadingSkeletonCategory() {
  return (
    <>
      <div className='mt-4 border-b-4 border-brand pb-4'>
        <LoadingBlock height='2.6em' width='25em' />
      </div>
      <div className='mt-4 grid grid-cols-2 gap-x-4 gap-y-6 sm:gap-x-8 lg:grid-cols-3 lgc:grid-cols-5'>
        <LoadingBlock />
        <LoadingBlock />
        <LoadingBlock />
        <div className='hidden 2xl:block'>
          <LoadingBlock />
        </div>
        <div className='hidden 2xl:block'>
          <LoadingBlock />
        </div>
      </div>
    </>
  );
}
